import { Info } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Dialog, DialogTrigger, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { fmt } from '@/lib/api';
import { invoicePayment } from '@/components/InvoicePaymentCell';
import { InvoiceSentStatus } from '@/components/InvoiceSentStatus';

export const invoiceDate = value => /^\d{4}-\d{2}-\d{2}/.test(value || '') ? value.slice(0, 10).split('-').reverse().join('/') : value || '—';

export const InvoiceDetails = ({ doc: d, clientName, profit, showSent }) => {
  const payment = invoicePayment(d);
  const fields = [
    ['Klant', clientName, `invoice-detail-client-${d.id}`],
    ['Datum', invoiceDate(d.datum), `invoice-detail-date-${d.id}`],
    ['Vervaldatum', invoiceDate(d.verval), `invoice-detail-due-${d.id}`],
    ['Excl. btw', fmt(d.excl || 0), `invoice-detail-excl-${d.id}`],
    ['Btw', fmt(d.btw_totaal || 0), `invoice-detail-vat-${d.id}`],
    ['Totaal', fmt(d.totaal), `invoice-detail-total-${d.id}`],
    ['Betaald', fmt(payment.paid), `betaald-bedrag-${d.id}`],
    ['Laatste betaling', invoiceDate(d.laatste_betaling), `invoice-payment-date-${d.id}`],
    ['Creditnota’s', fmt(payment.credit), `invoice-credit-${d.id}`],
    ['Te betalen', fmt(payment.balance), `invoice-detail-balance-${d.id}`],
    ['Gestructureerde mededeling', d.ogm || '—', `doc-ogm-${d.id}`],
  ];
  if (profit?.volledig) fields.push(['Winst', fmt(profit.winst), `invoice-detail-profit-${d.id}`], ['Marge', profit.marge_pct == null ? '—' : `${profit.marge_pct}%`, `winst-marge-${d.id}`]);
  const links = [
    ...(d.gefactureerd && d.factuur_id ? [{ id: d.factuur_id, label: 'Factuur', testId: `gefactureerd-${d.id}` }] : []),
    ...(d.leverbon_id ? [{ id: d.leverbon_id, label: 'Leverbon', testId: `leverbon-aangemaakt-${d.id}` }] : []),
    ...(d.bestelbon_id ? [{ id: d.bestelbon_id, label: 'Bestelbon', testId: `bestelbon-aangemaakt-${d.id}` }] : []),
    ...(d.creditnota_ids || []).map((id, i) => ({ id, label: 'Creditnota', testId: `creditnota-link-${d.id}-${i}` })),
  ];
  return <span className="inline-flex align-middle" onClick={e => e.stopPropagation()}>
    <Dialog>
      <DialogTrigger asChild><button type="button" className="invoice-detail-trigger" title="Factuurdetails" aria-label={`Details van ${d.id}`} data-testid={`invoice-details-trigger-${d.id}`}><Info size={14} /></button></DialogTrigger>
      <DialogContent className="bg-white text-gray-900 w-[calc(100vw-24px)] max-w-xl max-h-[85dvh] overflow-y-auto" aria-describedby={undefined} data-testid={`invoice-details-${d.id}`}>
        <DialogTitle className="text-base">Factuur {d.id}</DialogTitle>
        {showSent && <InvoiceSentStatus doc={d} />}
        <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-3">
          {fields.map(([label, value, testId]) => <div key={testId} className="min-w-0"><dt className="text-[11px] text-gray-500">{label}</dt><dd className="text-sm font-medium break-words" data-testid={testId}>{value}</dd></div>)}
        </dl>
        {d.bron === 'shop' && <div className="text-xs" data-testid={`lev-badge-${d.id}`}>{(d.levering_type || 'afhaal') === 'levering' ? 'Levering' : 'Afhaal'}{d.gewenste_datum ? ` · ${invoiceDate(d.gewenste_datum)}` : ''}</div>}
        {links.length > 0 && <div className="border-t pt-3 flex flex-col gap-2" data-testid={`doc-info-${d.id}`}>
          {links.map(link => <Link key={link.testId} to={`/documenten/${link.id}/bewerk`} className="text-xs text-blue-800 underline break-all" data-testid={link.testId}>{link.label} {link.id}</Link>)}
        </div>}
      </DialogContent>
    </Dialog>
  </span>;
};